function pop_mc(e, t) {
    if ("string" != typeof e && (e = "#mc"), null === document.querySelector(e)) return !1;
    var o, n, a;
    "number" != typeof t && (t = 2);
    o = Math.floor(5 * Math.random() + 5), n = Math.floor(5 * Math.random() + 1), a = Math.floor(Math.random() * t + 1), document.querySelector(e + " #mc_form_c_1").value = o, document.querySelector(e + " #mc_form_c_2").value = n, document.querySelector(e + " #mc_form_c_3").value = a, document.querySelector(e + " #mc_form_op").innerHTML = ["+", "-", "&times;"][a - 1]
}

function addCMGEvent() {
    var e = document.getElementsByName("web_form[form_name]"), t = e.length, o = googleAnalyticsType();
    if (t < 1) return console.log("No CMG forms detected."), !1;
    if (null == o) return console.log("No Google Analytics tracking code detected."), !1;
    for (var n = 0; n < t; n++) {
        var a = findAncestor(e[n], "form");
        console.log("CMGForm detected:", a), a.onsubmit = function (e) {
            e.preventDefault();
            var t = this, n = this.submit, a = this.querySelector("[name='web_form[form_name]']"),
                r = createTimestamp(), c = "CT_" + a.value + "_" + r.value, u = "webform-submit";
            switch (this.appendChild(r), o) {
                case"_gaq":
                    _gaq.push(["_set", "hitCallback", createFunctionWithTimeout(function () {
                        handleSubmit(n), t.submit()
                    })]),
                        _gaq.push(["_trackEvent", c, u]);
                    break;
                case"ga":
                    ga("send", "event", c, u, {
                        hitCallback: createFunctionWithTimeout(function () {
                            handleSubmit(n), t.submit()
                        }),
                    });
                    break;
                case"gtag":
                    gtag("event", u, {
                        event_category: c, event_callback: createFunctionWithTimeout(function () {
                            handleSubmit(n), t.submit()
                        }),
                    })
            }
            console.log(o + " " + u + " event " + c + " triggered.")
        }
    }
}

function googleAnalyticsType() {
    var e = null;
    return "function" == typeof gtag ? (console.log("Google Tag Manager detected"), e = "gtag") : "object" == typeof _gaq ? (console.log("_gaq detected"), e = "_gaq") : "function" == typeof ga && (console.log("Google Analytics detected"), e = "ga"), e
}

function findAncestor(e, t) {
    for (t = t.toLowerCase(); (e = e.parentElement) && e.tagName.toLowerCase() != t;) ;
    return e
}

function createFunctionWithTimeout(e, t) {
    var o = !1;
    return setTimeout(e, t || 1e3), function () {
        o || (o = !0, e())
    }
}

function createTimestamp() {
    var e = document.createElement("input");
    return e.type = "hidden", e.name = "web_form[submission_timestamp]", e.value = Math.round((new Date).getTime() / 1e3), e
}

function handleSubmit(e) {
    "object" == typeof e && (console.log("removing submit button"), e.parentNode.removeChild(e))
}

window.addEventListener ? (window.addEventListener("load", pop_mc, !1), window.addEventListener("load", addCMGEvent, !1)) : window.attachEvent && (!function () {
    var e = document.createStyleSheet(), t = function (t, o) {
        var n, a = document.all, r = a.length, c = [];
        for (e.addRule(t, "foo:bar"), n = 0; n < r && !("bar" === a[n].currentStyle.foo && (c.push(a[n]), c.length > o)); n += 1) ;
        return e.removeRule(0), c
    };
    document.querySelectorAll || document.querySelector || (document.querySelectorAll = function (e) {
        return t(e, 1 / 0)
    }, document.querySelector = function (e) {
        return t(e, 1)[0] || null
    })
}(), window.attachEvent("onload", pop_mc), window.attachEvent("onload", addCMGEvent));


// WEBPACK FOOTER //
// ./scripts/cmgform_html_5.js